import DressupCharacter from '@/objects/dressupCharacter';
import XyloButton from '../objects/xyloButton';
import BaseScene from '../objects/baseScene';
import HelpHand from '../objects/helpHand';

export default class CharacterSelect extends BaseScene {

  constructor() {
    super({
      key: 'CharacterSelect'
    });
  }

  /**
   *  Called when a scene is initialized. Method responsible for setting up
   *  the game objects of the scene.
   *
   *  @protected
   *  @param {object} data Initialization parameters.
   */

  init(data) {
    super.init(data);
    this.characterID = data.characterID;
    this.activeSlots = data.activeSlots;
    this.placedItems = data.placedItems;
    this.freezeAnim = data.freezeAnim;
    this.freezeTime = data.freezeTime;
  }

  create() {
    super.create();
    let x = this.screenWidth;
    let y = this.screenHeight;
    this.bg.setTexture('gameBG');
    this.bg.setOrigin(0.5, 0.5);
    // this.bg.setScale(1.3, 1.3);
    this.bg.setDisplaySize(x, y);
    this.bg.setDepth(-20);

    this.pressedXylophone = false;

    this.xyloButton = new XyloButton(
      this,
      x / 2,
      this.charSelected ? y - 10 : y + 80,
      y + 80,
      () => {
        this.simulateXlyophonePressed();
      },
      this.characterID === undefined,
      true,
      this.uiGroup,
    );

    if (this.charSelected) {
      this.bgEvent = this.time.delayedCall(3000, () => this.simulateXlyophonePressed());
    }

    //  TODO: Replace this content with really cool game code here :)
    this.count = 0;
    this.charIndex = 0;
    this.characters = [];
    this.charSelected = false;

    let outroDelay = 500;
    let restartDelay = 2400;

    this.charData = this.cache.json.get('data').characters;
    this.dressupData = this.cache.json.get('data').dressupConfig;
    for (let i = 0; i < this.charData.length; i++) {
      let params = this.charData[i];
      if (params.type !== 'static') {
        let c = new DressupCharacter(
          this,
          i,
          params.spine, // the key of the object in cache
          params.skin,
          params.animations,
          params.sfx,
          params.slots
        );

        c.setTransform(
          params.posX, // X positon
          params.posY, // Y position
          params.scale,
          params.scale,
          params.direction
        );
        c.setSortOrder(-15);
        c.canIdle = false;
        c.idleActive = false;
        this.characterGroup.add(c);
        this.characters.push(c);


        if (this.characterID !== undefined) {
          if (i == this.characterID) {
            //let scale = (params.dressupScale / this.dressupData.scaleX) * (this.dressupData.itemScale / params.dressupScale);
            let scale = (this.dressupData.itemScale) / this.dressupData.scaleX; // (this.dressupData.scaleX * e));// * params.dressupScale;/

            console.log('dance item scale --> ' + scale);
            //console.log('char item scaling --> (' + (1 / params.dressupScale) + ' / ' + this.dressupData.scaleX + ') * ' + this.dressupData.itemScale + ' = ' + scale);
            c.populateSlots(this, this.activeSlots, this.placedItems, scale);
            c.freeze(this, this.freezeAnim, this.freezeTime);
            c.toggleEyes(true);
            // this.time.delayedCall(outroDelay, () => this.playOutro(c));
          } else {
            c.canIdle = true;
            c.idleActive = true;
            c.toggleEyes(false);
            c.resetIdle();
            this.time.delayedCall(outroDelay * 1.5, () => this.playCelebrate(c));

          }
        } else {
          this.setInteractive(c, true);
          this.xyloButton.blocked = true;
          this.showHelp(false);
        }
      }

      this.characterGroup.depth = 5;
      this.uiGroup.depth = 15;
      this.popupGroup.depth = 25;
    }

    this.characterSFX = this.cache.json.get('data').characterSFX;
    //this.mumSFX = this.characterSFX[this.characterSFX.length - 1].sounds;
    //this.mumSFX.sort(() => Math.random() - 0.5);


    if (this.characterID !== undefined) {
      this.xyloButton.active = true;
    }
    else {
      this.xyloButton.active = false;
    }

    this.helpHand = new HelpHand(this, this.x, this.y, this.bg);
    this.helpHand.setDepth(5);

    //console.log(this.characterID);
    if (this.characterID !== undefined) {
      // this.endEvent = this.time.delayedCall(restartDelay, () =>
      //   this.laughAtDressupCharacter()
      // );
      this.laughAtDressupCharacter();
      this.canIdle = false;
    } else {
      this.bgMusic = this.sound.add('bgmusic', { loop: true, volume: 0.7 });
      this.bgMusic.play();
      this.canIdle = true;
    }
    this.toggleMute(this.mute);
  }

  simulateXlyophonePressed() {
    if (!this.pressedXylophone) {
      this.pressedXylophone = true;
      this.playOutro(this.characters[this.characterID]);
      this.xyloButton.active = false;
    }
  }

  playOutro(character) {
    this.xyloButton.animateOut(this, () => character.danceThenAnimateClothes(this, () => this.restartInteraction()));//character.animateClothes(this));
  }



  playCelebrate(character) {
    // character.idleActive = false;
    // character.canIdle = false;
    // character.resetIdle();
    // character.playHappy(this);//, character.animations.happy, 0.25, false, true);
  }

  setInteractive(c, canDance) {
    c.emitter.on(
      'characterClicked',
      () => {
        if (this.paused === false) {
          if (this.charSelected === false) {
            this.canIdle = false;
            this.charSelected = true;
            this.xyloButton.animateIn(this, () => this.handleCharacterClicked(c.ID));
            this.xyloButton.active = false;
          }
        }
      },
      this
    );
    if (canDance) {
      c.startDance(this, false);
    }
  }

  restartInteraction() {
    for (let i = 0; i < this.characters.length; i++) {
      let c = this.characters[i];
      this.setInteractive(c, this.characterID == i ? false : true);
    }

    this.xyloButton.active = true;
    this.canIdle = true;
    this.idleTime = 0;
  }

  playIdle() {
    let i = Math.floor((Math.random() * this.characters.length));
    let c = this.characters[i];
    this.helpHand.tapHandAtPoint(c.transform.x, c.y);
  }

  laughAtDressupCharacter() {
    for (let i = 0; i < this.characters.length; i++) {
      let c = this.characters[i];
      if (this.characterID !== i) {
        c.startGiggle(this);
      }
    }
    //this.sound.play(this.mumSFX[0]);
  }

  handleCharacterClicked(charID) {
    // do something when character clicked
    this.bgEvent = undefined;
    for (var i = 0; i < this.characters.length; i++) {
      let char = this.characters[i];
      if (char.ID == charID) {
        char.toggleFreeze(/* this */);
        this.freezeAnim = char.animations.dance[
          char.danceIdx
        ];
        this.freezeTime = char.freezeTime;
      } else {
        //this.characters[i].stopMove();
        char.dancing = false;
        this.time.delayedCall(Phaser.Math.Between(0, 500), () => char.playHappy(this, false));
      }
    }
    //this.sound.play(this.mumSFX[Phaser.Math.Between(1, this.mumSFX.length - 1)], { volume: 0.75 });
    this.characterID = charID;
    this.endEvent = this.time.delayedCall(2500, () => this.handleCharacterSelected());
  }

  handleCharacterSelected() {
    this.scene.stop('CharacterSelect');
    this.scene.start('Dressup', {
      characterID: this.characterID,
      freezeAnim: this.freezeAnim,
      freezeTime: this.freezeTime,
      mute: this.mute
    });
    this.cleanup();
  }

  handleGameOver() {
    for (let i = 0; i < this.characters.length; ++i) {
      this.characters[i].kill();
    }
  }

  cleanup() {
    this.charData = null;
    this.bg.destroy();
    this.bg = null;
    super.cleanup();
  }
}
